import React from 'react';
import {
    Row, Col
} from 'reactstrap';

class EmployeesEmailList extends React.Component {

    render() {
        this.props.info('EmployeesEmailList.js/render');
        const employees = this.props.employees != null ?
            this.props.employees
            : [];
        return (
                    <Row className='text-left px-3'><Col>
                    {employees.filter(employee => employee.active).map(employee => employee.email).join(', ')}
                    </Col></Row>
        );
    }
}

export default EmployeesEmailList;